<template>
  <LoadingWrapper :state="status">
    <ul v-if="data.length" class="mb-16 flex flex-col gap-0.5">
      <li
        v-for="survey in data"
        :key="survey.templateId"
        class="*:rounded-md! first:*:rounded-t-xl! last:*:rounded-b-xl!"
      >
        <SurveyCard :survey="survey" />
      </li>
    </ul>
    <EmptyPage
      v-if="!data.length"
      :title="$t('survey.empty')"
      :description="$t('survey.emptyInfo')"
      icon="ballot"
    >
      <BaseTextButton class="mb-8 hidden lg:flex" color="filled" icon="add" @click="openDialog">{{
        $t('survey.actions.create')
      }}</BaseTextButton>
    </EmptyPage>

    <RequestFeedbackDialog :is-open="isOpen" @close-dialog="closeDialog" />
  </LoadingWrapper>
</template>
<script lang="ts" setup>
  import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
  import { useDialog } from '../../../core/components/base/dialog/use-dialog'
  import EmptyPage from '../../../core/components/empty-states/EmptyPage.vue'
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import SurveyCard from '../../dashboard/components/SurveyCard.vue'
  import RequestFeedbackDialog from '../../request-feedback/RequestFeedbackDialog.vue'
  import { useSurveys } from '../composables/useSurveys'
  import { SurveyState } from '../models/survey-state'

  const { data, status } = useSurveys({ states: [SurveyState.running, SurveyState.draft] })

  const { isOpen, openDialog, closeDialog } = useDialog()
</script>
